import { createFeatureSelector, createSelector } from '@ngrx/store';

import { officeFeatureKey, State } from '../reducers/office.reducer';

export const selectOfficeFeature = createFeatureSelector<State>(officeFeatureKey);

export const selectContactCardPhotoUrl = createSelector(
  selectOfficeFeature,
  (state: State) => state.contactCardPhotoUrl
);

export const selectCalculatorsEnabled = createSelector(selectOfficeFeature, (state: State) => state.calculatorsEnabled);

export const selectNetSheetsEnabled = createSelector(selectOfficeFeature, (state: State) => state.netSheetsEnabled);

export const selectWalkingFarmEnabled = createSelector(selectOfficeFeature, (state: State) => state.walkingFarmEnabled);

export const selectOrderTitleEnabled = createSelector(selectOfficeFeature, (state: State) => state.orderTitleEnabled);

export const selectOrderTitleEmail = createSelector(selectOfficeFeature, (state: State) => state.orderTitleEmail);

export const selectDocumentLinksEnabled = createSelector(
  selectOfficeFeature,
  (state: State) => state.documentLinksEnabled
);

export const selectContactCardEnabled = createSelector(selectOfficeFeature, (state: State) => state.contactCardEnabled);

export const selectSchoolDistrictInfo = createSelector(selectOfficeFeature, (state: State) => state.schoolDistrictInfo);
